(function ($) {
    var dot = '.';

    var navSectionClass = 'navigation__section';
    var buttonSectionClass = 'navigation__section-button';

    var buttonClass = 'header-nav-button';

    var navSectionClassEnabled = navSectionClass + '--enabled';
    var navSectionClassHidden = navSectionClass + '--hidden';

    // Show and hide the main navigation menu at small screen sizes via a change
    // of class name.
    $(function () {
        var navSection = $(dot + navSectionClass);
        var buttonSection = $(dot + buttonSectionClass);
        var button = buttonSection.find(dot + buttonClass);

        // No navigation menu?
        if (navSection.length === 0) {
            return;
        }

        // No button? Add button and, if necessary, its container element.
        if (button.length === 0) {
            if (buttonSection.length === 0) {
                buttonSection = $('<div class="' + buttonSectionClass + '"></div>');
                navSection.before(buttonSection);
            }

            button = $('<button class="' + buttonClass + '" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z" /></svg> <span class="screen-reader-text">Menu</span></button>');
            buttonSection.append(button);
        }

        // Toggle "hidden" class on navigation section when button is clicked.
        button.on('click', function (e) {
            e.stopPropagation();
            navSection.toggleClass(navSectionClassHidden);
        });

        // Add "hidden" class to hide navigation on page load. Add "enabled"
        // class to allow additional styles to be applied to the navigation menu
        // when it can be toggled.
        navSection.addClass([
            navSectionClassEnabled,
            navSectionClassHidden
        ]);

        // Hide the navigation menu when the user clicks elsewhere on the page.
        $('html').on('click', function (e) {
            navSection.addClass(navSectionClassHidden);
        });
    });
})(jQuery);
